export default {
  index: "Dashboard",
  shopping: "Shopping",
  reports: "Reports",
  recharge: "Recharge",
  settings: "Settings",
};
